import BaseTable from 'components/Tables/BaseTable';
import { sortBy } from 'lodash';
import FlowListDetailPanel from 'pages/ScenarioExposure/Flow/ScenariosManagement/FlowListDetailPanel';
import React from 'react';
import { connect } from 'react-redux';
import { lookUpIdValueSelector } from 'selectors/generic';
import theme from 'source/theme';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioConditions';
import { TABLE_HEIGHT_SPLIT_4VIEW } from 'utils/ui/constants';
import { currentUser } from 'selectors/currentUser';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_4VIEW(64);

const Component = props => {
  const {
    conditionsById, descriptorId, flowsById, scenariosById, scenarioDescriptors,
    scenarioDescriptorConditionsData, units, user
  } = props;

  const selectedSD = scenarioDescriptors.filter(sd =>
    (descriptorId && sd.descriptor_id === descriptorId)
  );

  let filteredSDC = {};
  const sdcConditionRepetitions = [];

  selectedSD.forEach(sSD => {
    const flowId = scenariosById[sSD.scenario_id].flow_id;
    const flowInfo = {
      flow_id: flowId,
      code: flowsById[flowId].code,
      name: flowsById[flowId].name
    };
    const sdcs = scenarioDescriptorConditionsData.filter(sdc => sdc.scenario_descriptor_id === sSD.id);
    sdcs.forEach(sdc => {
      if (sdcConditionRepetitions.includes(sdc.condition_id)) {
        filteredSDC[sdc.condition_id].flowsInfo.push(flowInfo);
      } else {
        filteredSDC[sdc.condition_id] = { ...sdc, flowsInfo: [flowInfo] };
        sdcConditionRepetitions.push(sdc.condition_id);
      }
    });
  });

  const rows = Object.values(filteredSDC).map(element => {
    const subtype = conditionsById[element.condition_id].subtype;
    const name = conditionsById[element.condition_id].name;
    return { ...element, subtype, name };
  });

  const rowsSorted = sortBy(rows, ['subtype', 'id']);

  return (
    <React.Fragment>
      <BaseTable
        title={'CONDIÇÕES DO FLUXO'}
        columns={columns(user, units)}
        data={descriptorId ? rowsSorted : []}
        order={false}
        paging={false}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          rowStyle: () => ({ backgroundColor: theme.palette.background.veryLight })
        }}
        detailPanel={[
          () => ({
            icon: tableIcons.Flow,
            tooltip: 'Fluxogramas',
            render: ({ rowData }) => <FlowListDetailPanel row={rowData} />
          })
        ]}
      />
    </React.Fragment>
  );
};

const makemapStateToProps = () => {
  const units = lookUpIdValueSelector('units', ['name']);
  const mapStateToProps = (state, props) => ({
    conditionsById: state.conditions.models,
    flowsById: state.flows.models,
    scenariosById: state.scenarios.models,
    scenarioDescriptorConditionsData: state.scenarioDescriptorConditions.data,
    units: units(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

export default connect(makemapStateToProps)(Component);
